import brandConfig from "../../src/ssi/brand.config";

/**
 * Zugriff auf die Mandanten-Stammdaten aus `src/ssi/brand.config.js`. Dieses Modul ist die einzige
 * Stelle, die die Feldnamen der Klassifizierung kennt:
 * - `touchpoint`: "web" | "app" | "ereader" — auf welchem Kanal die Seite läuft
 * - `appCallbackProtocol`: Protokoll für App-Callbacks, nur bei App-Mandanten gesetzt
 *
 * Alle Funktionen arbeiten ausschließlich auf einer übergebenen Mandanten-ID. Welcher Mandant die
 * aktuelle Seite ist, ermittelt `getMandantId()`.
 */

const TOUCHPOINT_APP = "app";

/**
 * @param {String} mandantId
 * @returns {Object|null} Stammdaten des Mandanten oder `null`, wenn die ID unbekannt ist
 */
export function getBrandForMandantId(mandantId) {
	const brand = brandConfig.brands[mandantId];
	if (!brand) {
		return null;
	}
	return brand;
}

/**
 * @returns {String[]} alle konfigurierten Mandanten-IDs
 */
export function getAllMandantIds() {
	return Object.keys(brandConfig.brands);
}

/**
 * @param {String} mandantId
 * @returns {String} Touchpoint des Mandanten, leer wenn die ID unbekannt ist
 */
export function getTouchpointForMandantId(mandantId) {
	const brand = getBrandForMandantId(mandantId);
	if (!brand) {
		return "";
	}
	return brand.touchpoint;
}

/**
 * @param {"web"|"app"|"ereader"} touchpoint
 * @returns {String[]} alle Mandanten-IDs des übergebenen Touchpoints
 */
export function getMandantIdsByTouchpoint(touchpoint) {
	const mandantIds = [];
	for (const mandantId of getAllMandantIds()) {
		if (getTouchpointForMandantId(mandantId) === touchpoint) {
			mandantIds.push(mandantId);
		}
	}
	return mandantIds;
}

/**
 * @returns {String[]} alle Mandanten-IDs, die nicht in einer App-Webview laufen
 */
export function getNonAppMandantIds() {
	const mandantIds = [];
	for (const mandantId of getAllMandantIds()) {
		if (getTouchpointForMandantId(mandantId) !== TOUCHPOINT_APP) {
			mandantIds.push(mandantId);
		}
	}
	return mandantIds;
}

/**
 * Prüft, ob der Mandant in einer App-Webview läuft.
 * @param {String} mandantId
 * @returns {boolean}
 */
export function isAppMandant(mandantId) {
	return getTouchpointForMandantId(mandantId) === TOUCHPOINT_APP;
}

/**
 * @param {String} mandantId
 * @returns {String} Protokoll für App-Callbacks, leer wenn der Mandant keine App-Webview ist
 */
export function getAppCallbackProtocol(mandantId) {
	const brand = getBrandForMandantId(mandantId);
	if (!brand || !brand.appCallbackProtocol) {
		return "";
	}
	return brand.appCallbackProtocol;
}
